<div class="weekly-consol-planning-page">
  <form [formGroup]="planningForm">
    <mat-card>
      <mat-card-content>

        <mat-form-field appearance="fill" class="fieldSize">
          <mat-label required>Week No</mat-label>
          <input matInput formControlName="weekNo" readonly>
          <mat-datepicker-toggle matSuffix [for]="weekPicker"></mat-datepicker-toggle>
          @if (planningForm.get('weekNo')?.touched && planningForm.get('weekNo')?.hasError('required')) {
            <mat-error
              >
              Week No is required
            </mat-error>
          }
        </mat-form-field>

        <input matInput [matDatepicker]="weekPicker" (dateChange)="onDateSelected($event.value)"
          style="width:0; height:0; opacity:0; position:absolute; left:-9999px">
          <mat-datepicker #weekPicker [dateClass]="highlightWeek">
          </mat-datepicker>

          <mat-form-field class="fieldSize">
            <mat-label>From</mat-label>
            <input matInput [value]="planningForm.get('fromDate')?.value | date:'dd-MM-yyyy'" readonly>
          </mat-form-field>

          <mat-form-field class="fieldSize">
            <mat-label>To</mat-label>
            <input matInput [value]="planningForm.get('toDate')?.value | date:'dd-MM-yyyy'" readonly>
          </mat-form-field>

          <br>
            <div class="add-row-wrapper">
              <mat-form-field appearance="fill">
                <mat-label>POL</mat-label>
                <mat-select placeholder="POL" (selectionChange)="setPolValueChangeEvent($event.value)"
                  formControlName="polId" required>
                  <mat-option>
                    <ngx-mat-select-search [searching]="searching" [formControl]="polSearchCtrl"
                      noEntriesFoundLabel="'no matching found'" placeholderLabel=" Search Port Of Loading(POL)">
                      <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (pol of filteredPol | async; track pol) {
                    <mat-option [value]="pol.id">
                      {{pol.name}} ({{pol.code}})
                    </mat-option>
                  }
                </mat-select>
                @if ( polId.touched  && polId.hasError('required')) {
                  <mat-error>
                    POL is required
                  </mat-error>
                }
              </mat-form-field>

              <button mat-raised-button (click)="copyFromPreviousWeek()" class="light-blue-btn"
                matTooltip="Copy previous week Destinations" matTooltipPosition="above">
                Copy Prev Week Destinations <mat-icon iconPositionEnd>content_copy</mat-icon>
              </button>

              @if (addPermission) {
                <button mat-raised-button class="add-row-btn" (click)="addRow()" matTooltip="Add new row"
                  matTooltipPosition="left">
                  Add Row
                  <mat-icon>add_circle</mat-icon>
                </button>
              }
            </div>

            <div class="mat-elevation-z8">
              <table mat-table formArrayName="planningDetails" [dataSource]="weeklyDetailsDataSource | async">

                <ng-container matColumnDef="destination">
                  <th mat-header-cell *matHeaderCellDef>
                    <span class="sort-header" (click)="sortByDestination()">
                      Destination
                      <mat-icon class="sort-icon">{{ destinationSortDirection === 'asc' ? 'arrow_upward' : destinationSortDirection === 'desc' ? 'arrow_downward' : 'unfold_more' }}</mat-icon>
                    </span>
                    <div class="sorting_header">
                      <input matInput placeholder="Search" [formControl]="destinationFilterCtrl" autocomplete="off">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                    <mat-form-field appearance="fill">
                      <mat-select formControlName="destinationId" placeholder="Destination"
                        (selectionChange)="setDestinationValueChangeEvent($event.value, getRowIndex(element))">
                        <mat-option>
                          <ngx-mat-select-search [searching]="searching"
                            [formControl]="destinationSearchCtrl"
                            noEntriesFoundLabel="'No matching found'"
                            placeholderLabel="Find Destination">
                            <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                          </ngx-mat-select-search>
                        </mat-option>
                        @for (d of filteredDestinations | async; track d) {
                          <mat-option [value]="d.id">
                            {{ d.name }} ({{ d.code }})
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>

                        <ng-container matColumnDef="vesselVoyage">
                            <th mat-header-cell *matHeaderCellDef>Vessel / Voyage
                                 <mat-icon class="vv-refresh-icon" matTooltip="Refresh vessel voyage list"
                                    [class.disabled]="reloadingVesselVoyages" (click)="reloadVesselVoyages()">refresh</mat-icon>
                                <div class="sorting_header">
                                    <input matInput placeholder="Search" [formControl]="vesselVoyageFilterCtrl">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="vesselVoyageId" placeholder="Select Vessel Voyage"
                                        (selectionChange)="setVesselVoyageValueChangeEvent($event.value, getRowIndex(element))">
                                        <mat-option>
                                            <ngx-mat-select-search [searching]="searching"
                                                [formControl]="vesselVoyageSearchCtrls[getRowIndex(element)]"
                                                noEntriesFoundLabel="'No matching voyage found'"
                                                placeholderLabel="Find Vessel Voyage">
                                                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                                            </ngx-mat-select-search>
                                        </mat-option>

                        @for (vv of filteredVesselVoyagesPerRow[getRowIndex(element)] | async; track vv) {
                          <mat-option [value]="vv.id"
                            [disabled]="isVesselVoyageUsed(vv.id, getRowIndex(element), element)">
                            {{ vv.vesselName }} ({{ vv.voyageNo }})
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Haz Planning -->
                <ng-container matColumnDef="hazPlanning">
                  <th mat-header-cell *matHeaderCellDef>Haz Planning</th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                    <mat-form-field appearance="fill" style="max-width: 90px;">
                      <mat-select formControlName="isHaz">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Transit Time -->
                <ng-container matColumnDef="transitTime">
                  <th mat-header-cell *matHeaderCellDef>Transit Time</th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                    <mat-form-field appearance="fill" style="max-width: 90px;">
                      <input matInput type="number" formControlName="transitTime" />
                      <span matSuffix>Days</span>
                      @if (element.get('transitTime')?.hasError('pattern') && element.get('transitTime')?.touched) {
                        <mat-error>
                          whole numbers only
                        </mat-error>
                      }
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Tentative Stuffing Date -->
                <ng-container matColumnDef="tentativeStuffingDate">
                  <th mat-header-cell *matHeaderCellDef>
                    <span class="sort-header" (click)="sortByStuffingDate()">
                      Tentative Stuffing
                      <mat-icon class="sort-icon">{{ stuffingDateSortDirection === 'asc' ? 'arrow_upward' : stuffingDateSortDirection === 'desc' ? 'arrow_downward' : 'unfold_more' }}</mat-icon>
                    </span>
                    <div class="sorting_header">
                      <input matInput placeholder="Search" [formControl]="stuffingDateFilterCtrl">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                    <div class="date-container">
                      <mat-form-field appearance="fill" class="date-field-cell">
                        <input matInput [matDatepicker]="stuffingPicker" formControlName="tentativeStuffingDate"
                          (dateChange)="onDateFieldChange(element, 'tentativeStuffingDate')" (click)="stuffingPicker.open()"
                          placeholder="Select date" readonly>

                          <div matSuffix class="d-flex">
                            <mat-datepicker-toggle matSuffix [for]="stuffingPicker"></mat-datepicker-toggle>
                            <mat-datepicker #stuffingPicker></mat-datepicker>

                            @if (getConfirmFlag('tentativeStuffingDate', getRowIndex(element))) {
                              <button mat-icon-button color="primary" class="text-success" matTooltip="Confirm"
                                (click)="onConfirm(element, 'tentativeStuffingDate')"
                                >
                                <mat-icon>check_circle</mat-icon>
                              </button>
                            }
                          </div>
                        </mat-form-field>
                      </div>
                    </td>
                  </ng-container>

                  <!-- ETD POL -->
                  <ng-container matColumnDef="etdPol">
                    <th mat-header-cell *matHeaderCellDef>
                      <span class="sort-header" (click)="sortByEtdPol()">
                        ETD POL
                        <mat-icon class="sort-icon">{{ etdPolSortDirection === 'asc' ? 'arrow_upward' : etdPolSortDirection === 'desc' ? 'arrow_downward' : 'unfold_more' }}</mat-icon>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                      <div class="date-container">
                        <mat-form-field appearance="fill" class="date-field-cell">
                          <input matInput [matDatepicker]="etdPicker" formControlName="etdPol"
                            (dateChange)="onDateFieldChange(element, 'etdPol')" (click)="etdPicker.open()"
                            placeholder="Select date" readonly>

                            <div matSuffix class="d-flex">
                              <mat-datepicker-toggle matSuffix [for]="etdPicker">
                                <!-- <mat-icon matDatepickerToggleIcon>clear</mat-icon> -->
                              </mat-datepicker-toggle>
                              <mat-datepicker #etdPicker></mat-datepicker>

                              @if (getConfirmFlag('etdPol', getRowIndex(element))) {
                                <button mat-icon-button color="primary" class="text-success" (click)="onConfirm(element, 'etdPol')"
                                  matTooltip="Confirm">
                                  <mat-icon>check_circle</mat-icon>
                                </button>
                              }
                            </div>
                          </mat-form-field>
                        </div>
                      </td>
                    </ng-container>

                    <!-- Port Cutoff -->
                    <ng-container matColumnDef="portCutoff">
                      <th mat-header-cell *matHeaderCellDef>Port Cutoff</th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        {{ element.get('portCutoff')?.value ? (element.get('portCutoff')?.value | date:'dd-MM-yyyy') : '- - -' }}
                      </td>
                    </ng-container>

                    <!-- Haz Cutoff -->
                    <ng-container matColumnDef="hazCutoff">
                      <th mat-header-cell *matHeaderCellDef>Haz Cutoff</th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        {{ element.get('hazCutoff')?.value ? (element.get('hazCutoff')?.value | date:'dd-MM-yyyy') : '- - -' }}
                      </td>
                    </ng-container>

                    <!-- SI Cutoff -->
                    <ng-container matColumnDef="siCutoff">
                      <th mat-header-cell *matHeaderCellDef>SI Cutoff</th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        {{ element.get('siCutoff')?.value ? (element.get('siCutoff')?.value | date:'dd-MM-yyyy') : '- - -' }}
                      </td>
                    </ng-container>

                    <!-- Routing -->
                    <ng-container matColumnDef="routingId">
                      <th mat-header-cell *matHeaderCellDef>Routing
                        <div class="sorting_header">
                          <input matInput placeholder="Search" [formControl]="routingIdFilterCtrl">
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        <mat-form-field appearance="fill" style="max-width: 150px;">
                          <mat-select formControlName="routingId">
                            @for (pod of element.get('routingIdOptions')?.value; track pod) {
                              <mat-option
                                [value]="pod.id">
                                {{ (pod.id === 0 || pod.id === -1) ? pod.name : pod.name + ' (' + pod.code + ')' }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- View Previous Vessel -->
                    <ng-container matColumnDef="viewPreviousVessel">
                      <th mat-header-cell *matHeaderCellDef> View Previous Vessel </th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)" class="view-btn-cell">
                        <button mat-mini-fab class="square-btn" color="primary"
                          matTooltip="Show Previous Vessels" (click)="openPreviousVesselPopup(element.value)">
                          <mat-icon>history</mat-icon>
                          Show
                        </button>
                      </td>
                    </ng-container>

                    <!-- In Hand CBM -->
                    <ng-container matColumnDef="inHandCbm">
                      <th mat-header-cell *matHeaderCellDef>In Hand CBM</th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        <mat-form-field appearance="fill" style="max-width: 90px;">
                          <input matInput formControlName="inHandCbm" (keypress)="restrictDecimalInput($event, 3)">
                          @if (element.get('inHandCbm')?.hasError('pattern')
                            && element.get('inHandCbm')?.touched) {
                            <mat-error>
                              max 3 decimal places
                            </mat-error>
                          }
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- In Hand Weight -->
                    <ng-container matColumnDef="inHandWeight">
                      <th mat-header-cell *matHeaderCellDef>In Hand Weight</th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        <mat-form-field appearance="fill" style="max-width: 90px;">
                          <input matInput formControlName="inHandWeight" (keypress)="restrictDecimalInput($event, 3)">
                          @if (element.get('inHandWeight')?.hasError('pattern')
                            && element.get('inHandWeight')?.touched) {
                            <mat-error>
                              max 3 decimal places
                            </mat-error>
                          }
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Short Fall CBM -->
                    <ng-container matColumnDef="shortFallCbm">
                      <th mat-header-cell *matHeaderCellDef>Short Fall CBM</th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        <mat-form-field appearance="fill" style="max-width: 90px;">
                          <input matInput formControlName="shortFallCbm" (keypress)="restrictDecimalInput($event, 3)">
                        </mat-form-field>
                        @if (element.get('shortFallCbm')?.hasError('pattern')
                          && element.get('shortFallCbm')?.touched) {
                          <mat-error>
                            max 3 decimal places
                          </mat-error>
                        }
                      </td>
                    </ng-container>

                    <!-- Status -->
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef>Status
                        <div class="sorting_header">
                          <input matInput placeholder="Search" [formControl]="statusFilterCtrl">
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)">
                        <mat-form-field appearance="fill">
                          <mat-select formControlName="status">
                            <mat-option value="OPEN">Open</mat-option>
                            <mat-option value="PLANNING_IN_PROGRESS">Planning In Progress</mat-option>
                            <mat-option value="PLANNING_COMPLETED">Planning Completed</mat-option>
                            <mat-option value="CANCELLED">Cancelled</mat-option>
                            <mat-option value="MORE_CARGO_AWAITED">More Cargo Awaited</mat-option>
                            <mat-option value="STUFFING_RESCHEDULED_FOR_TOMORROW">Stuffing Rescheduled For
                            Tomorrow</mat-option>
                            <mat-option value="STUFFING_COMPLETED">Stuffing Completed</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef> Action </th>
                      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="getRowIndex(element)" class="icon-cell">
                        <button mat-icon-button color="warn" (click)="deleteRow(getRowIndex(element))"
                          [disabled]="planningDetails.length <= 1" matTooltip="Delete">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="weeklyColumns" class="blue-header"></tr>
                    <tr mat-row *matRowDef="let row; columns: weeklyColumns;"></tr>
                  </table>
                </div>

                @if (noDataAvailable) {
                  <div class="no-data-banner">
                    <div class="no-data-banner__icon-wrap">
                      <mat-icon>add_chart</mat-icon>
                    </div>
                    <div class="no-data-banner__body">
                      <span class="no-data-banner__title">No Planning Found</span>
                      <span class="no-data-banner__message">
                        No plan exists for the selected <strong>Week</strong> and <strong>POL</strong>. <br>Click <strong>Add Row</strong> to create New Planning.
                      </span>
                    </div>
                  </div>
                }

                <mat-card-actions>
                  <!-- <span fxLayout="column" *ngIf="id.value">
                  <span fxLayout="row" fxLayoutGap="16px">
                    <span class="p-2">
                      <mat-checkbox (change)="canViewLogs($event)" fxLayoutAlign="center center">
                        View Log
                      </mat-checkbox>
                    </span>
                  </span>
                  <app-history *ngIf="isLogVisible" [referenceType]="'POST_STUFF_PHYSICAL_STUFFING'" [referenceId]="id.value"></app-history>
                </span> -->
                <!-- *ngIf="getSaveDisableCondn()"
                *ngIf="isRevertBtn" -->

                @if (planningForm.dirty && ((id?.value && editPermission) || (!id?.value && addPermission))) {
                  <button mat-button color="primary" (click)="onSave()">Save</button>
                }
                @if (planningForm.get('polId')?.value && planningForm.get('weekNo')?.value) {
                  <button mat-button color="cancel" (click)="onCancel()">Cancel</button>
                }
                @if (id?.value && deletePermission) {
                  <button mat-button color="cancel" (click)="onRevert()">Revert Process</button>
                }
              </mat-card-actions>

            </mat-card-content>
          </mat-card>
        </form>
      </div>